import React, { useEffect, useState } from 'react';
import { Checkbox, Icon, Modal } from 'semantic-ui-react';

import Button from '../../../components/Button';
import { MAX_RECIPIENT_ATTEMPTS } from '../utils/biometryCopy';

type Props = {
  open: boolean;
  loading?: boolean;
  maxAttempts?: number;
  subjectLabel?: string;
  onConfirm: () => void;
  onClose: () => void;
};

const ResetAttemptsConfirmModal: React.FC<Props> = ({
  open,
  loading = false,
  maxAttempts = MAX_RECIPIENT_ATTEMPTS,
  subjectLabel = 'recebedor',
  onConfirm,
  onClose
}) => {
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!open) {
      setConfirmed(false);
    }
  }, [open]);

  const handleClose = () => {
    setConfirmed(false);
    onClose();
  };

  const handleConfirm = () => {
    if (!confirmed || loading) return;
    onConfirm();
  };

  return (
    <Modal open={open} onClose={handleClose} size="small" closeIcon>
      <Modal.Header>
        <Icon name="undo" color="orange" />
        Resetar tentativas de biometria
      </Modal.Header>
      <Modal.Content>
        <p style={{ marginTop: 0 }}>
          O {subjectLabel} esgotou as {maxAttempts} tentativas de biometria. Ao confirmar:
        </p>
        <ul style={{ marginTop: 8, marginBottom: 16, paddingLeft: 20 }}>
          <li>
            Serão liberadas {maxAttempts} novas tentativas para tentar a biometria novamente
          </li>
          <li>O histórico anterior de tentativas será mantido</li>
          <li>Nenhum recebedor novo será criado agora na Pagar.me</li>
        </ul>
        <Checkbox
          label="Entendo que esta ação apenas libera novas tentativas"
          checked={confirmed}
          onChange={(_, data) => setConfirmed(Boolean(data.checked))}
        />
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" light text="Cancelar" onClick={handleClose} disabled={loading} />
        <Button
          type="button"
          text="Resetar tentativas"
          onClick={handleConfirm}
          loading={loading}
          disabled={!confirmed || loading}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default ResetAttemptsConfirmModal;
